import React, { type FC } from "react";
import { withPrefix } from "@tracking/tracking";
import { useModalState } from "clientState/AuthFlow/providers/ModalScreenProvider";
import { useTrackElement, useTranslation } from "@edreamsodigeo/frontend-core";
import {
  Box,
  Glyph,
  SystemModalCloseIcon,
  SystemModalHeader,
} from "@edreamsodigeo/prisma-design-system";

import { type CloseHeaderProps } from "./contract";

const sx = {
  background: "linear-gradient(135deg, #DA3835 0%, #F9700D 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  minHeight: "0px",
  height: "0px",
};

const CloseHeader: FC<CloseHeaderProps> = ({
  closeScreen,
  screen,
  trackingPrefix,
}) => {
  const { t } = useTranslation();
  const trackingRef = useTrackElement(
    ["click"],
    withPrefix(`${screen}_close`, trackingPrefix),
  );

  /* istanbul ignore next */
  const { isCloseable = true } = useModalState();

  return (
    <SystemModalHeader type="critical" sx={sx}>
      {isCloseable && (
        <SystemModalCloseIcon
          onClose={(): void => closeScreen(false)}
          sx={{ left: "auto", right: "big" }}
        >
          <Box
            ref={trackingRef}
            aria-label={t("authentication.header.close")}
            role="button"
          >
            <Glyph
              category="UIActions"
              name="Clear"
              size="small"
              color="neutral.80"
            />
          </Box>
        </SystemModalCloseIcon>
      )}
    </SystemModalHeader>
  );
};

export default CloseHeader;
